import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { COMMENT_CREATE } from '../queries';
import { useMutation } from './base';
;
export const useCommentCreateMutation = ({ endpoint, queryKey: parentQueryKey, parentId, }) => {
    const queryKey = [
        parentQueryKey[0],
        {
            ...parentQueryKey[1],
            parentId,
        },
    ];
    const client = useQueryClient();
    return useMutation(COMMENT_CREATE, endpoint, {
        onSuccess: (data) => {
            const comment = data;
            client.setQueryData(queryKey, (old) => {
                const defaultVal = {
                    pageParams: [],
                    pages: [],
                };
                const updated = produce(old || defaultVal, (draft) => {
                    if (!draft.pages.length) {
                        draft.pages.push({
                            comments: [data],
                            meta: {
                                count: 1,
                                page: 0,
                                pageCount: 1,
                                perPage: 20,
                                nextPage: undefined,
                                prevPage: undefined,
                            },
                        });
                    }
                    else {
                        draft.pages[0].comments.unshift(data);
                    }
                });
                return updated;
            });
            client.setQueryData(parentQueryKey, (old) => {
                const defaultVal = {
                    pageParams: [],
                    pages: [],
                };
                const updated = produce(old || defaultVal, (draft) => {
                    if (draft.pages.length) {
                        let isFound = false;
                        for (let page of draft.pages) {
                            if (isFound)
                                break;
                            for (let idx = 0; idx < page.comments.length; idx++) {
                                if (page.comments[idx].id === parentId) {
                                    page.comments[idx].childrenCount += 1;
                                    isFound = true;
                                    break;
                                }
                            }
                        }
                    }
                });
                return updated;
            });
        },
    }, (data) => data.comment);
};
//# sourceMappingURL=useCommentCreateMutation.js.map